import { AuthState } from '../../store/auth/authReducer';
import { UserProfile } from '../../store/types';
import { isTokenExpired } from '../../utils/helpers/tokenUtils';
import LS from '../../utils/localStorageUtils';

export function loadAuthFromStorage(): Partial<AuthState> {
	const token = LS.get('access_token') || undefined;

	const validToken = token && !isTokenExpired(token) ? token : undefined;

	let user: UserProfile | undefined;
	const u = LS.get('auth_user');
	if (u) {
		try {
			user = JSON.parse(u) as UserProfile;
		} catch {}
	}

	return {
		token: validToken,
		isLogged: Boolean(validToken),
		user: validToken ? user : undefined,
		loading: false,
		error: undefined,
		// statistics: null,
	};
}

// Native has no synchronous storage, so loadAuthFromStorage() finds nothing at boot and
// the cached profile has to be pulled out of AsyncStorage before the profile request lands.
export async function loadStoredUser(): Promise<UserProfile | undefined> {
	const raw = await LS.getAsync('auth_user');
	if (!raw) return undefined;

	try {
		return JSON.parse(raw) as UserProfile;
	} catch {
		return undefined;
	}
}

export function clearAuthFromStorage() {
	LS.remove('access_token');
	LS.remove('refresh_token');
	LS.remove('auth_user');
}
